import type { AxiosInstance } from 'axios';
import axiosRetry from 'axios-retry';
import type { NetworkMetricsBatch, WIDMetricsBatch } from './types';

const RETRY_COUNT = 2;
const RETRY_DELAY_IN_MS = 1500;

export default class MetricsApi {
  private readonly api: AxiosInstance;

  constructor(api: AxiosInstance) {
    this.api = api;
    axiosRetry(this.api, {
      retries: RETRY_COUNT,
      shouldResetTimeout: true,
      retryDelay: (retryCount) => retryCount * RETRY_DELAY_IN_MS,
      retryCondition: (error) => /^\/?log\//.test(error.config?.url ?? '') || false,
    });
  }

  async sendNetworkMetrics(metrics: NetworkMetricsBatch): Promise<void> {
    await this.api.post('/analytics/network-metrics', metrics);
  }

  async sendWIDMetrics(metrics: WIDMetricsBatch): Promise<void> {
    await this.api.post('/analytics/wid-metrics', {
      ...metrics,
    });
  }
}
